// import React, { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import { apiService } from "../Config/api.service";
import { signalerErreur } from "../Utils/signalerErreur";

const EmployeeSelect = ({
    value,
    onChange,
    isDisabled = false,
    placeholder,
    minInputLength = 2,
    nameKey = "name",
    employeeId,
    ...props
}) => {
    const { t } = useTranslation();
    const resolvedPlaceholder = placeholder ?? t('employeeSelect.choosePlaceholder');
    const [searchFailed, setSearchFailed] = useState(false);
    const loadEmployeeOptions = async (inputValue, callback) => {
        if (!inputValue || inputValue.length < minInputLength) {
            setSearchFailed(false);
            callback([]);
            return;
        }
        try {
            // Corriger ici car le getElement ne recupere que le nbr de résultats par page
            const response = await apiService.getElement(`/employees?asearch=${encodeURIComponent(inputValue)}`);
            const employees = response.data.employees || [];
            setSearchFailed(false);
            callback(
                employees.map(emp => ({
                    value: emp.id,
                    label: emp[nameKey] || `${emp.name} ${emp.poste}`,
                }))
            );
        } catch (e) {
            signalerErreur(e, 'EmployeeSelect.loadEmployeeOptions');
            setSearchFailed(true);
            callback([]);
        }
    };

    return (
        <AsyncSelect
            cacheOptions
            defaultOptions
            loadOptions={loadEmployeeOptions}
            value={value}
            onChange={onChange}
            placeholder={resolvedPlaceholder}
            isClearable
            isDisabled={isDisabled}
            noOptionsMessage={({ inputValue }) =>
                searchFailed
                    ? t('employeeSelect.searchError')
                    : !inputValue || inputValue.length < minInputLength
                        ? t('employeeSelect.startTyping')
                        : t('tableList.noResultFound')
            }
            {...props}
        />
    );
};

export default EmployeeSelect;